export default {
    methods: {
        initRequestParams: function(ctx) {
            var params = {
                format: "json",
                limit: ctx.perPage,
                offset: (ctx.currentPage - 1) * ctx.perPage
            }

            if (ctx.sortBy) {
                var ordering = {
                    order_by: (ctx.sortDesc ? "-" : "") + ctx.sortBy
                }

                params = {...params, ...ordering}
            }

            if (ctx.filter) {
                params = {...params, ...{q: ctx.filter}}
            }

            return params
        }
    }
}